import { render, staticRenderFns } from "./UlDialogApprove.vue?vue&type=template&id=0d1c0515&"
import script from "./UlDialogApprove.vue?vue&type=script&lang=ts&"
export * from "./UlDialogApprove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports